import { gql } from '@/lib/graphql/gql'

export const WEBHOOK_QUERY = gql`
  query Webhook($idCompany: String!, $idWebhook: String!) {
    company(id: $idCompany) {
      webhook(id: $idWebhook) {
        id
        idCompany
        endpoint
      }
    }
  }
`
